import React from 'react'
import PropTypes from 'prop-types'
import Heading from '../components/Heading'
import ModuleWithLoader from '../components/ModuleWithLoader'
import SubHeader from '../components/SubHeader'
import MasterSwitchForm from '../forms/MasterSwitchForm'
import CustomLink from '../components/CustomLink'
import globals from '../globals'

const SafeSearch = (props) => {
    const handleChange = value => {
        globals.pushEvent(value ? 'HsSafeSearchToggleOn' : 'HsSafeSearchToggleOff')
        props.updateServiceDetails({ safeSearchEnabled: value })
    }

    return (
        <div className='module'>
            <Heading title='Safe search' />
            <ModuleWithLoader isLoaded hasError={false} className='p-4'>
                <div className='row mb-5'>
                    <div className='col-12 col-md-10 offset-md-1 text-center'>
                        <SubHeader
                            content='With the flick of the Master Switch below, you can simultaneously trigger Safe Search on Google, YouTube, Bing and Yandex, on all devices connected to your home internet connection. This occurs regardless of whether you have enabled cookies or not. Once activated, the Safe Search setting cannot be changed or deactivated from a device’s Search Engine settings. For example, you cannot go to Google’s Safe Search settings locally on a device and deactivate Safe Search.'
                            className='mb-5'
                        />
                        <MasterSwitchForm
                            serviceId={props.serviceId}
                            isEnabled={props.isEnabled}
                            postUrl='/api/postToggleSafeSearch'
                            title='Safe Search Master Switch'
                            subTitle='Disabling will allow unfiltered search results to be displayed by your Search Engine'
                            type='Safe Search'
                            handleChange={handleChange}
                        >
                            {props.isEnabled &&
                                <div className='col-12 col-lg-6 offset-lg-3 text-center mt-2'>
                                    <p className='color-red lh'>
                                        <span className='bold'>Please note:</span><br />Depending on your browser and usage patterns Safe Search  may take several minutes (or longer) to disable. Clearing your browser cache will immediately disable Safe Search.
                                    </p>
                                </div>}
                        </MasterSwitchForm>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-12 mb-4'>
                        <h2 className='m-0 mb-3 text-center'>When Home Secure Safe Search is enabled, here’s what happens</h2>
                    </div>
                    <div className='col-12 col-md-10 offset-md-1'>
                        <p className='mt-0 mb-4 lh'><span className='bold'>Google Safe Search:</span> Google will "block inappropriate or explicit images from your Google Search results".<br /><CustomLink to='https://google.com/preferences'>More details</CustomLink></p>
                        <p className='my-4 lh'><span className='bold'>YouTube Restricted Mode:</span> YouTube will "hide videos that may contain inappropriate content flagged by users and other signals".<br /><CustomLink to='https://youtube.com/features'>More details</CustomLink></p>
                        <p className='my-4 lh'><span className='bold'>Bing Safe Search 'Moderate':</span> Bing will "block adult images and videos but not text from your search results".<br /><CustomLink to='https://www.bing.com/account'>More details</CustomLink></p>
                        <p className='mt-4 mb-0 lh'><span className='bold'>Yandex Family Search 'Moderate Filter':</span> Yandex will "block sites for adults. They are excluded from search results if the query is not explicitly searching for such resources".<br /><CustomLink to='https://yandex.com/support/search/additional-features/adult-filter.html'>More details</CustomLink></p>
                    </div>
                </div>
            </ModuleWithLoader>
        </div>
    )
}

SafeSearch.propTypes = {
    serviceId: PropTypes.number.isRequired,
    isEnabled: PropTypes.bool,
    updateServiceDetails: PropTypes.func.isRequired
}

export default SafeSearch



// WEBPACK FOOTER //
// ./resources/js/modules/SafeSearch.js